import { render, staticRenderFns } from "./VehicleGroupList.vue?vue&type=template&id=4d1c4360&scoped=true&"
import script from "./VehicleGroupList.vue?vue&type=script&lang=js&"
export * from "./VehicleGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c4360",
  null
  
)

export default component.exports